import React from "react";

export default function AllSubjects() {
  return (
    <div className="w-full">
      <p>All Subjects</p>
    </div>
  );
}
